<template>
  <div>
    <el-popover :disabled="disabled" placement="top" trigger="hover" popper-class="pop-Style">
      <div class="realValue">{{ real_value }}</div>
      <span ref="table-pop-content" class="span-ellipsis" slot="reference">
        {{ real_value }}
      </span>
    </el-popover>
  </div>
</template>
<script>
import { checkEllipsis } from "./pop"
export default {
  name: "PopContent",
  props: {
    row: {},
    cusprop: {}
  },
  data() {
    return {
      disabled: true,
    };
  },
  computed: {
    real_value() {
      var val = this.$jsonPath(this.row, this.cusprop);
      if (val === 0) {
        return val;
      }
      return !!val ? val : "-";
    },
  },
  watch: {
    real_value() {
      this.$nextTick(() => {
        this.checkEllipsis();
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkEllipsis();
    });
  },
  methods: {

    checkEllipsis() {
      var res = checkEllipsis(this.$refs["table-pop-content"]);
      this.disabled = !res;
    }
  },
};
</script>
<style lang="scss">
.span-ellipsis {
  cursor: pointer;
  width: auto;
  visibility: visible;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-inline-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.pop-Style {
  padding: 18px 20px;
  width: auto !important;
  min-width: auto;
  max-width: 500px;

  .realValue {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
